import { createFileRoute } from "@tanstack/react-router";

import { Button } from "~/components/ui/button";
import { useAuth } from "~/hooks/use-auth";

export const Route = createFileRoute("/_main/admin/")({
  component: AdminDashboard,
});

function AdminDashboard() {
  const { signOut } = useAuth();
  return (
    <div className="flex flex-col items-center justify-center h-full">
      <img src="/images/logo-3d.png" className="h-64 p-4" />
      <Button onClick={signOut} variant="destructive">
        SIGN OUT
      </Button>
    </div>
  );
}
